import { SiteCoreDictionary } from './types';

const fallbackDictionary: SiteCoreDictionary = {
    visaCalculatorMainHeader: 'Sjekk kursen',
    visaCalculatorMainDescription: 'Se veksklingskursen du får i utlandet når du bruker kortet ditt',
    visaCalculatorReadMoreText: 'Vekslingskursen er foreløpig beregnet og avvik kan forekomme',
    visaCalculatorReadMoreButton: 'Les mer',
    visaCalculatorDetailsHeaderDesktop: 'Om kursen',
    visaCalculatorDetailsHeaderMobile: 'Vekslingskursen er foreløpig beregnet og avvik kan forekomme',
    visaCalculatorDetailsInfoPrices:
        'Vær oppmerksom på at våre beregninger kan avvike noe mot faktisk belastet beløp. Vi kan i tillegg ta et valutapåslag',
    visaCalculatorDetailsInfoPriceList: 'se prisliste for dette',
    visaCalculatorDetailsInfoVisa:
        'Våre kurser baserer seg på kurser fra Visa som blir oppdatert en gang om dagen. Kursene er beregnet for bruk av kort.',
    visaCalculatorDetailsInfoDate: 'Kursene du ser er hentet',
    visaCalculatorCurrency: 'Valuta',
    visaCalculatorCurrencySearch: 'Søk etter valuta',
    visaCalculatorCurrencyOptionsMostCommon: 'Mest vanlige',
    visaCalculatorCurrencyOptionsAll: 'Alle valuta',
    visaCalculatorCurrencyNotSelected: 'Velg valuta',

    visaCalculatorErrorCouldNotFetchCurrencies: 'Vi klarte dessverre ikke å hente tilgjengelige valutaer',
    visaCalculatorErrorCouldNotFetchConvertRate: 'Vi klarte dessverre ikke å hente vekslingskursen',
    visaCalculatorRedirectButtonTitle: 'Valutakalkulator',
};

export default fallbackDictionary;
